import { PortableWifiOff } from '@mui/icons-material';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { setBroadcastSelectedItem } from 'app/actions/map';
import { Scrollbar } from 'app/components';
import { useStateRef } from 'app/services';
import HJPlayer from 'hjplayer';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTransportBroadcastList = function () {
  const dispatch = useDispatch();
  const broadcastRefs = useRef([]);
  const { terid } = useSelector((state) => state.map.transportSelectedItem.broadcast);
  const { transportBroadcastSelectedItem } = useSelector((state) => state.map);
  const [broadcastPlayers, setBroadcastPlayers, broadcastPlayersRef] = useStateRef(
    config.mapBroadcastChannels.map(() => {
      return {
        player: null,
        status: 'pending',
      };
    })
  );

  const handleItemClick = (value) => dispatch(setBroadcastSelectedItem(value));

  useEffect(() => {
    if (!HJPlayer.isSupported()) {
      return;
    }

    broadcastRefs.current.forEach((element, key) => {
      const channel = element.attributes.getNamedItem('id').value;
      // Распределение каналов по портам: 1-3 -> 12061, 4-6 -> 12062, 7-9 -> 12063
      const port = channel <= 3 ? 61 : channel <= 6 ? 62 : 63;
      const player = new HJPlayer(
        {
          type: 'flv',
          isLive: false,
          hasAudio: false,
          hasVideo: true,
          duration: 1,
          url: `${config.mapBroadcastUrl}:120${port}/live.flv?devid=${terid}&chl=${channel}&st=1&audio=0`,
        },
        {
          enableStashBuffer: false,
          autoCleanupSourceBuffer: true,
        }
      );

      player.attachMediaElement(element);
      player.load();

      player.on(HJPlayer.Events.MEDIA_INFO, () => {
        setBroadcastPlayers(
          broadcastPlayersRef.current.map((currentPlayer, currentKey) => {
            return {
              ...currentPlayer,
              status: key === currentKey ? 'fulfilled' : currentPlayer.status,
            };
          })
        );

        player.pause();

        setTimeout(() => {
          player.off();
          player.unload();
        }, config.mapBroadcastTimeout);
      });

      player.on(HJPlayer.Events.ERROR, (reason) => {
        switch (reason) {
          case 'NETWORK_ERROR':
          case 'MEDIA_ERROR':
            // eslint-disable-next-line no-case-declarations
            const broadcastPlayers = broadcastPlayersRef.current.map((currentPlayer, currentKey) => {
              return {
                ...currentPlayer,
                status: key === currentKey ? 'rejected' : currentPlayer.status,
              };
            });

            setBroadcastPlayers(broadcastPlayers);
            break;
        }
      });

      setBroadcastPlayers(
        broadcastPlayersRef.current.map((currentPlayer, currentKey) => {
          return {
            player: key === currentKey ? currentPlayer.player : player,
            status: currentPlayer.status,
          };
        })
      );
    });

    return () => {
      broadcastPlayersRef.current.forEach((currentPlayer) => {
        currentPlayer.player.unload();
        currentPlayer.player.off();
        currentPlayer.player.detachMediaElement();
      });
    };
  }, [terid]);

  return (
    <Stack direction='column' sx={{ height: '100%' }}>
      <Scrollbar>
        <Box
          component='div'
          sx={(theme) => ({
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            height: '100%',
            gap: theme.spacing(1),
            padding: theme.spacing(2),
          })}>
          {config.mapBroadcastChannels.map((value, key) => (
            <Stack
              key={key}
              direction='column'
              alignItems='center'
              justifyContent='center'
              onClick={() => handleItemClick(value)}
              sx={(theme) => ({
                maxWidth: '50%',
                height: '80px',
                flex: `1 1 calc((100% / 2) - ${theme.spacing(1)})`,
                '&:hover': {
                  cursor: 'pointer',
                },
              })}>
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  position: 'relative',
                  bgcolor: 'background.default',
                  borderRadius: theme.shape.borderRadius,
                  overflow: 'hidden',
                  border: '2px solid',
                  borderColor: 'transparent',
                  video: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'fill',
                  },
                  ...(transportBroadcastSelectedItem === value && {
                    borderColor: theme.palette.primary.main,
                  }),
                })}>
                <video id={value} ref={(el) => (broadcastRefs.current[key] = el)} />
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    'svg:not(.MuiCircularProgress-svg)': {
                      color: 'text.secondary',
                    },
                  }}>
                  {broadcastPlayers[key].status === 'rejected' && <PortableWifiOff fontSize='small' />}
                  {broadcastPlayers[key].status === 'pending' && <CircularProgress size={18} />}
                </Stack>
              </Stack>
              <Typography component='span'>{`Камера ${value}`}</Typography>
            </Stack>
          ))}
        </Box>
      </Scrollbar>
    </Stack>
  );
};

export default MapTransportBroadcastList;
